/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import moment from 'moment-timezone';
import platform from 'platform';
import { isEmpty } from 'lodash';
import { isJelMobile } from '@/helpers/AppHelpers';
import { checkInferieurNbJourLimite, getStatutDesactivation } from '@/helpers/ProduitHelpers';
import { PageMappingCasino } from '@/helpers/PageMappingHelpers';
import JelWorkspace from '@/store/classes/jelWorkspace';
import i18n from '@/js/i18n';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';

const jelWorkspace = new JelWorkspace({
  module: 'produitCasino',
  refreshMinProd: process.env.VUE_APP_STORE_PRODUIT_CASINO_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
  imageDefaut: getImageDefaut(),
};
const getters = {
  ...jelWorkspace.getters,
  getLienInterneFromProduit:
    (state, getters) =>
    (produit, urlParams = null) => {
      return {
        field: 'lienInterne',
        lienInterne: produit ? getProduitRouteFromProduit(produit) : '',
        urlParams,
        isDejaNettoye: true,
      };
    },

  // Retourne un array trié/filtré de Produits par idProduitCollection
  getArrayProduitByProduitCollection:
    (state, getters, rootState, rootGetters) => (produitCollection) => {
      // Ne rien retourner si la liste n'est pas encore inutilisée
      // ou si la collection a été détruite (produitCollection = null)
      if (!state.liste || !produitCollection) {
        return null;
      }

      const maintenant = moment();

      // FILTRER
      const listeProduit = state.liste.filter((produit) => {
        // On initialise pour le tri des produits Favoris et Joues Recemment
        produit.isJoueRecemment = false;
        produit.dateJoueRecemment = null;
        produit.isFavori = false;
        produit.dateFavori = null;

        // On cherche à éliminer des produits en retournant false

        // Exclure un jeu qui n'est pas encore lancé
        if (maintenant.isBefore(moment(produit.dateLancement).tz('America/Montreal', true)))
          return false;

        // Exclure un jeu qui n'est pas supporté par le canal courant (Internet/Mobile)
        if (
          (isJelMobile() && produit.indMobile != 'true') ||
          (!isJelMobile() && produit.indInternet != 'true')
        )
          return false;

        // CRITÈRES GÉNÉRAUX
        if (produitCollection.hasCritereGeneral) {
          // Titre du jeu (exclure si pas de correspondance autant en FR qu'en EN)
          if (produitCollection.titreJeuFr || produitCollection.titreJeuEn) {
            if (
              !(
                (produitCollection.titreJeuFr &&
                  produit.titreFr
                    .toLowerCase()
                    .indexOf(produitCollection.titreJeuFr.toLowerCase()) != -1) ||
                (produitCollection.titreJeuEn &&
                  produit.titreEn
                    .toLowerCase()
                    .indexOf(produitCollection.titreJeuEn.toLowerCase()) != -1)
              )
            ) {
              return false;
            }
          }

          // Mise min (!!: si n'est pas null ou zéro)
          if (!!produitCollection.miseIntervalleMin || !!produitCollection.miseIntervalleMax) {
            if (
              parseFloat(produit.miseMin) < parseFloat(produitCollection.miseIntervalleMin) ||
              parseFloat(produit.miseMin) > parseFloat(produitCollection.miseIntervalleMax)
            ) {
              return false;
            }
          }

          // Jeu lancé depuis x jours
          if (produitCollection.lanceDepuis) {
            if (!checkInferieurNbJourLimite(produit.dateLancement, produitCollection.lanceDepuis))
              return false;
          }

          if (
            produitCollection.indJoueRecemment == 'true' &&
            produitCollection.indFavori == 'true'
          ) {
            if (
              !rootGetters['preferences/isJoueRecemment'](produit) &&
              !rootGetters['preferences/isFavori'](produit)
            ) {
              return false;
            }
            // Identifier les produits joués récemment et favoris pour le tri de la collection 'pour-vous'
            if (rootGetters['preferences/isJoueRecemment'](produit)) {
              produit.isJoueRecemment = true;
              produit.dateJoueRecemment = moment(
                rootGetters['preferences/dateHeureJoueRecemment'](produit)
              ).tz('America/Montreal', true);
            }
            if (rootGetters['preferences/isFavori'](produit)) {
              produit.isFavori = true;
              produit.dateFavori = moment(rootGetters['preferences/dateHeureFavori'](produit)).tz(
                'America/Montreal',
                true
              );
            }
          } else {
            // Joués Récemment
            if (produitCollection.indJoueRecemment == 'true') {
              if (!rootGetters['preferences/isJoueRecemment'](produit)) {
                return false;
              }
              produit.isJoueRecemment = true;
              produit.dateJoueRecemment = moment(
                rootGetters['preferences/dateHeureJoueRecemment'](produit)
              ).tz('America/Montreal', true);
            }
            // Favoris
            if (produitCollection.indFavori == 'true') {
              if (!rootGetters['preferences/isFavori'](produit)) {
                return false;
              }
              produit.isFavori = true;
              produit.dateFavori = moment(rootGetters['preferences/dateHeureFavori'](produit)).tz(
                'America/Montreal',
                true
              );
            }
          }
        }

        // CRITÈRES PRODUITS CASINO
        if (produitCollection.hasCritereProduitCasino) {
          // Catégories
          if (produitCollection.hasListeCategorie) {
            const categorieTrouve = produitCollection.listeCategorie.find(
              (categorie) => categorie === produit.categorie
            );
            if (!categorieTrouve) return false;
          }

          // Étiquettes
          if (produitCollection.hasListeEtiquette) {
            if (produit.listeEtiquette?.['@nodes']?.length > 0) {
              const bTrouve = produitCollection.listeEtiquette.find((etiquette) => {
                return produit.listeEtiquette['@nodes'].find((node) => {
                  return produit.listeEtiquette[node].etiquette == etiquette;
                });
              });
              if (!bTrouve) return false;
            } else {
              return false;
            }
          }

          // Fournisseurs
          if (produitCollection.hasListeFournisseur) {
            const fournisseurTrouve = produitCollection.listeFournisseur.find(
              (fournisseur) => fournisseur === produit.fournisseur
            );
            if (!fournisseurTrouve) return false;
          }

          // Progressifs
          if (produitCollection.indProgressif == 'true' && !produit.idProgressif) return false;
          if (produitCollection.hasListeProgressif) {
            if (!produit.idProgressif) return false;

            const progressifTrouve = produitCollection.listeProgressif.find((progressif) => {
              return progressif === produit.idProgressif;
            });

            if (!progressifTrouve) return false;
          }

          if (produitCollection.typeJeu && produit.typeJeu != produitCollection.typeJeu)
            return false;

          // Disponibilité (au moins un critère)
          if (
            produitCollection.hasDisponibilite &&
            (produitCollection.indEnCasino != 'true' || produit.indEnCasino != 'true') &&
            (produitCollection.indOffertSalonJeux != 'true' ||
              produit.indOffertSalonJeux != 'true') &&
            (produitCollection.indVideoPoker != 'true' || produit.indVideoPoker != 'true') &&
            (produitCollection.indOffertDetaillant != 'true' ||
              produit.indOffertDetaillant != 'true') &&
            (produitCollection.achatGroupe != 'true' || produit.achatGroupe != 'true')
          ) {
            return false;
          }

          // Caractéristiques (au moins un critère)
          if (
            produitCollection.hasCaracteristique &&
            (produitCollection.indPartieGratuite != 'true' ||
              (produit.nbPartieGratuite ?? 0) == 0) &&
            (produitCollection.indRondeBoni != 'true' || (produit.nbRondeBoni ?? 0) == 0) &&
            (produitCollection.indMultiplicateur != 'true' ||
              produit.indMultiplicateur != 'true') &&
            (produitCollection.indArgentBoni != 'true' || produit.indArgentBoni != 'true') &&
            (produitCollection.indBoutonStop != 'true' || produit.indBoutonStop != 'true') &&
            (produitCollection.indScratch != 'true' || produit.indScratch != 'true') &&
            (produitCollection.indMegadrop != 'true' || produit.indMegadrop != 'true')
          ) {
            return false;
          }
        }
        if (produitCollection.hasCritereCED) {
          // TODO: CED
        }

        // Est affiché
        return true;
      });
      // LISTE PRODUITS CASINO
      // Si on a une liste fixe, on inclut obligatoirement le produit
      if (produitCollection.listeProduit) {
        produitCollection.listeProduit.forEach((uuidProduit) => {
          const targetElement = state.liste.find((element) => {
            if (uuidProduit == element['@id']) {
              return element;
            }
          });
          /* On ajoute les produits si ils ne sont pas déjà dans la liste
           * et si leur date de lancement est déjà atteinte
           */
          if (
            targetElement &&
            !listeProduit.includes(targetElement) &&
            maintenant.isAfter(moment(targetElement.dateLancement).tz('America/Montreal', true))
          ) {
            listeProduit.push(targetElement);
          }
        });
      }

      const titreLocale = `titre${capitalizeFirstLetter(i18n.locale)}`;

      // On trie les produits en fonction des critères sélectionnés
      listeProduit.sort((produit1, produit2) => {
        if (produit1 && produit2) {
          if (!produitCollection.ordreTri) {
            // Tri par défaut (date lancement), on veut sortir rapidement de la switch
          } else if (produitCollection.ordreTri == 'miseMin') {
            // miseMin ASC
            if (parseFloat(produit1.miseMin) > parseFloat(produit2.miseMin)) return 1;
            if (parseFloat(produit1.miseMin) < parseFloat(produit2.miseMin)) return -1;
          } else if (produitCollection.ordreTri == 'alphabetique') {
            // alphabétique ASC
            if (produit1[titreLocale].toLowerCase() > produit2[titreLocale].toLowerCase()) return 1;
            if (produit1[titreLocale].toLowerCase() < produit2[titreLocale].toLowerCase())
              return -1;
          } else if (produitCollection.ordreTri == 'etiquette') {
            // Trier selon étiquettes / ordre de l'étiquette
            if (produitCollection.listeEtiquette.length > 0) {
              // eslint-disable-next-line no-restricted-syntax
              for (const produitCollectionEtiquette of produitCollection.listeEtiquette) {
                const nodeProduit1 = produit1.listeEtiquette['@nodes'].find((nodeProduit) => {
                  return (
                    produit1.listeEtiquette[nodeProduit].etiquette == produitCollectionEtiquette
                  );
                });
                const etiquetteProduit1 = produit1.listeEtiquette[nodeProduit1];

                const nodeProduit2 = produit2.listeEtiquette['@nodes'].find((nodeProduit) => {
                  return (
                    produit2.listeEtiquette[nodeProduit].etiquette == produitCollectionEtiquette
                  );
                });
                const etiquetteProduit2 = produit2.listeEtiquette[nodeProduit2];

                if (etiquetteProduit1 && !etiquetteProduit2) return -1;
                if (!etiquetteProduit1 && etiquetteProduit2) return 1;
                if (etiquetteProduit1 && etiquetteProduit2) {
                  if (etiquetteProduit1.ordre != etiquetteProduit2.ordre) {
                    return (
                      (etiquetteProduit1.ordre ?? 9999999) - (etiquetteProduit2.ordre ?? 9999999)
                    );
                  }
                }
              }
            }
          }

          if (
            produitCollection.ordreTri != 'joueRecemmentFavori' &&
            produitCollection.ordreTri != 'favoriJoueRecemment'
          ) {
            // dateLancement DESC
            const dateLancement1 = moment(produit1.dateLancement).tz('America/Montreal', true);
            const dateLancement2 = moment(produit2.dateLancement).tz('America/Montreal', true);
            if (dateLancement1.isAfter(dateLancement2)) return -1;
            if (dateLancement1.isBefore(dateLancement2)) return 1;
          }
        }
        return 0;
      });

      if (
        produitCollection.ordreTri == 'joueRecemmentFavori' ||
        produitCollection.ordreTri == 'favoriJoueRecemment'
      ) {
        // On trie les listes JouesRecement et Favori
        listeProduit.sort((produit1, produit2) => {
          // Tri pour avoir les produits 'joués récemment' en premier pour affichage collection 'pour-vous'
          if (produitCollection.ordreTri == 'joueRecemmentFavori') {
            if (produit1.isJoueRecemment == true && produit2.isJoueRecemment == true) {
              // Tri par dateJoueRecemment DESC
              if (produit1.dateJoueRecemment.isAfter(produit2.dateJoueRecemment)) return -1;
              if (produit1.dateJoueRecemment.isBefore(produit2.dateJoueRecemment)) return 1;
            } else if (produit1.isJoueRecemment == true) {
              return -1;
            } else if (produit2.isJoueRecemment == true) {
              return 1;
            }
            if (produit1.isFavori == true && produit2.isFavori == false) {
              return -1;
            }
            if (produit1.isFavori == false && produit2.isFavori == true) {
              return 1;
            }
            if (produit1.isFavori == true && produit2.isFavori == true) {
              // Tri par dateFavori DESC
              if (produit1.dateFavori.isAfter(produit2.dateFavori)) return -1;
              if (produit1.dateFavori.isBefore(produit2.dateFavori)) return 1;
            }
            return 0;
          }
          // Tri pour avoir les produits 'favoris' en premier pour affichage collection 'pour-vous'
          if (produitCollection.ordreTri == 'favoriJoueRecemment') {
            if (produit1.isFavori == true && produit2.isFavori == true) {
              // Tri par dateFavori DESC
              if (produit1.dateFavori.isAfter(produit2.dateFavori)) return -1;
              if (produit1.dateFavori.isBefore(produit2.dateFavori)) return 1;
            } else if (produit1.isFavori == true) {
              return -1;
            } else if (produit2.isFavori == true) {
              return 1;
            }
            if (produit1.isJoueRecemment == true && produit2.isJoueRecemment == false) {
              return -1;
            }
            if (produit1.isJoueRecemment == false && produit2.isJoueRecemment == true) {
              return 1;
            }
            if (produit1.isJoueRecemment == true && produit2.isJoueRecemment == true) {
              // Tri par dateJoueRecemment DESC
              if (produit1.dateJoueRecemment.isAfter(produit2.dateJoueRecemment)) return -1;
              if (produit1.dateJoueRecemment.isBefore(produit2.dateJoueRecemment)) return 1;
            }
            return 0;
          }
        });
      }

      // TRIER : Jeux actifs en premier / inactifs en dernier
      listeProduit.sort((produit1, produit2) => {
        let statutProduitUn = null;
        let statutProduitDeux = null;
        if (produit1 && produit2) {
          statutProduitUn = getStatutDesactivation(produit1, isJelMobile());
          // Vérifie si l'intégrateur est désactivé
          if (statutProduitUn == null) {
            statutProduitUn = rootGetters['integrateur/getStatutIntegrateur'](
              produit1.integrateur,
              isJelMobile()
            );
          }
          statutProduitDeux = getStatutDesactivation(produit2, isJelMobile());

          // Vérifie si l'intégrateur est désactivé
          if (statutProduitDeux == null) {
            statutProduitDeux = rootGetters['integrateur/getStatutIntegrateur'](
              produit2.integrateur,
              isJelMobile()
            );
          }

          if (
            statutProduitUn &&
            statutProduitDeux &&
            !statutProduitUn.indDesactive &&
            statutProduitDeux.indDesactive
          )
            return -1;
          if (
            statutProduitUn &&
            statutProduitDeux &&
            statutProduitUn.indDesactive &&
            !statutProduitDeux.indDesactive
          )
            return 1;
        }
      });
      return listeProduit;
    },

  // Retourne un array trié/filtré de idProduit par idProduitCollection
  getArrayIdProduitCasinoByProduitCollection:
    (state, getters, rootState, rootGetters) => (produitCollection) => {
      const listeProduit = getters.getArrayProduitByProduitCollection(produitCollection);

      // Retourner la liste de uuid des produits
      const arrIdProduit = listeProduit.map((produit) => produit['@id']);

      return arrIdProduit;
    },

  isNouveaute: () => (produit) => {
    return checkInferieurNbJourLimite(
      produit.dateLancement,
      process.env.VUE_APP_NB_JOUR_NOUVEAU_PRODUIT
    );
  },

  getStatutProduit: (state, getters, rootState, rootGetters) => (produit, isMobile) => {
    // Vérifie si le jeu est désactivé
    const statutProduit = getStatutDesactivation(produit, isMobile);

    // Vérifie si l'intégrateur est désactivé
    if (!statutProduit.indDesactive) {
      const statutIntegrateur = rootGetters['integrateur/getStatutIntegrateur'](
        produit.integrateur,
        isMobile
      );
      statutProduit.indDesactive = statutIntegrateur?.indDesactive
        ? true
        : statutProduit.indDesactive;
    }

    statutProduit.indBloquant = false;
    statutProduit.indNonBloquant = false;

    // Vérifie s'il faut afficher une fenêtre informative
    if (produit.infoFenetreType && produit.infoFenetreType !== 'aucune') {
      let appareilValide = true;
      let navigateurValide = true;
      let plateformeValide = true;
      if (produit.infoFenetreAppareil) {
        switch (produit.infoFenetreAppareil) {
          case 'mobile':
            appareilValide = isMobile;
            break;
          case 'desktop':
            appareilValide = !isMobile;
            break;
          case 'telephone':
            // ATTENTION: Ne pas remplacer par this.$mq n'est pas reconnu sur Safari ce qui empêche le rendering de la page
            appareilValide = isMobile && window.innerWidth < 768;
            break;
          case 'tablette':
            // ATTENTION: Ne pas remplacer par this.$mq n'est pas reconnu sur Safari ce qui empêche le rendering de la page
            appareilValide = isMobile && window.innerWidth >= 768 && window.innerWidth < 992;
            break;
          default:
        }
      }
      if (produit.infoFenetreNavigateur.length > 0) {
        const navigateurActuel = platform.name.toLowerCase();
        navigateurValide = produit.infoFenetreNavigateur.some((elem) => {
          return navigateurActuel.includes(elem);
        });
      }
      if (produit.infoFenetrePlateforme.length > 0) {
        const plateformeActuelle =
          platform.os.family == 'OS X' ? 'mac' : platform.os.family.toLowerCase();
        plateformeValide = produit.infoFenetrePlateforme.some((elem) => {
          return plateformeActuelle == elem;
        });
      }
      if (appareilValide && navigateurValide && plateformeValide) {
        statutProduit.indBloquant = produit.infoFenetreType === 'bloquant';
        statutProduit.indNonBloquant = produit.infoFenetreType === 'nonBloquant';
        statutProduit.messageFenetre =
          produit.infoFenetreTexte ?? i18n.t('casino.desactivation.fenetreMessage');
      }
    }
    return statutProduit;
  },

  hasInfoSecondaire: () => (produit) => {
    // Lot Progressif ou MAS en direct avec Image Secondaire
    return (
      produit &&
      (produit.idProgressif ||
        (produit.categorie == 'mas' &&
          produit.typeJeu == 'masEnDirect' &&
          produit.image4 &&
          produit.image4['@name']))
    );
  },
};
const actions = {
  ...jelWorkspace.actions,
};
const mutations = {
  ...jelWorkspace.mutations,
  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
      // this.commit('produitCollection/INIT');
    }
  },
};

function getProduitRouteFromProduit(produit) {
  const pageMapping =
    i18n.locale == 'en'
      ? PageMappingCasino.CASINO_PRODUIT.siteUrlEn
      : PageMappingCasino.CASINO_PRODUIT.siteUrl;
  const categorie = i18n.t(`casino.categorie.${produit.categorie}.slug`);
  const name = i18n.locale == 'en' ? produit.nameEn : produit.name;

  return `${pageMapping}/${categorie}/${name}`;
}

function getImageDefaut() {
  return {
    '@id': 'jcr:cd645bfd-bf66-4fad-a5d9-d9967618f4c5',
    '@name': 'produitCasino.webp',
    '@path': '/jel/casino/defaut/produitCasino.webp',
    metadata: {
      format: 'image/webp',
    },
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
